import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { DraftsService } from '@services/drafts.service';
import {
    DraftInterface,
    DraftPickInterface,
    DraftYearInterface,
    ParticipantInterface,
    TradeInterface,
} from '@interfaces/drafts.interface';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../base.component';


@Component({
    selector: 'app-drafts',
    templateUrl: './drafts.component.html',
})
export class DraftsComponent extends BaseComponent implements OnDestroy, OnInit {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input()
    public tournamentId: number;

    public year: number | null;
    public round: number | null;

    public subscriber: Subscription;
    public draft: DraftInterface | null = null;

    public constructor(
        private draftService: DraftsService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.load();
    }

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }

    private async load(): Promise<any> {
        try {
            const data = await this.draftService.getDrafts(
                this.tournamentId,
                this.year,
                this.round,
            );

            this.subscriber = data.subscribe((data: DraftInterface) => {
                this.year = data.data?.draft.year ?? null;
                this.round = data.data?.round.number ?? null;
                this.draft = data;
            });
        } catch (e) {
            // console.log(e);
        }
    }

    public rounds(): number[] {
        if (this.draft === null) {
            return [];
        }

        const years = this.draft.years.filter((item : DraftYearInterface) => item.year === this.year);
        if (years.length !== 1) {
            return [];
        }

        return years[0]!.rounds;
    }

    public onYearChange(e: Event): void {
        this.year = +((e.target as HTMLInputElement).value);
        this.round = 1;
        this.load();
    }

    public onRoundChange(e: Event): void {
        this.round = +((e.target as HTMLInputElement).value);
        this.load();
    }

    public tradesChain(pick: DraftPickInterface): ParticipantInterface[] {
        const chain: ParticipantInterface[] = [];

        const tradesCount = pick.trades?.length ?? 0;
        pick.trades?.forEach((trade: TradeInterface, i: number):void => {
            chain.push(trade.from);

            if (tradesCount === i + 1) {
                chain.push(trade.to);
            }
        });

        return chain;
    }
}
